module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "d7e44112"
    }
  }, [_c('img', {
    attrs: {
      "alt": "page12",
      "src": "Images/page-12a.jpg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_toc_r1#d7e1656",
      "id": "d14e201"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#5B9ABB"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "page12",
      "src": "Images/page-12b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e44012"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_toc_r1#d7e1686",
      "id": "d14e204"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#5B9ABB"
    }
  }, [_vm._v("What Makes a"), _c('br'), _vm._v("Welcoming Home?")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "page12a",
      "src": "Images/page-12c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e45012"
    }
  }, [_vm._v("Where and how we live, what we do there, and how we embrace the space we’re given, is surely one of the world’s great themes. The "), _c('i', [_vm._v("Iliad")]), _vm._v(" may be about war, but the far greater "), _c('i', [_vm._v("Odyssey")]), _vm._v(" is about men who want nothing more than to get back to their wives, children, and vineyards. By the time she reaches the end of the Yellow Brick Road, Dorothy has no qualms at all about returning to a farm in Kansas. "), _c('i', [_vm._v("The Wind in the Willows’")]), _vm._v(" Mole, enticed to set off on a wild adventure, begins to long for “that little curtained world” left behind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e49012"
    }
  }, [_vm._v("Most of us have a home like this somewhere in our hearts. It’s the home we try to create every day. Some days we do a good job of it, some days we fall behind. Often, there’s a looming sense that we should be doing something—or doing more—than we are, but we aren’t quite sure what it is.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e50512"
    }
  }, [_vm._v("It’s a unique feature of the past few generations that many of us grew up in chore-free childhoods. Even the word “chore” has an old-fashioned ring to it. So do a few other words, like “visit,” “front porch,” and “gracious plenty.” Yet all of these words, and the things they represent, are part of that home we strive for, whether we know it or not.")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e54013"
    }
  }, [_vm._v("PUTTING THE ELEMENTS TOGETHER")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e55113"
    }
  }, [_vm._v("Over the years, we’ve kept the ideal but lost much of the knowledge of what it took to get there. My mother, the first woman in her family to work outside the home, never learned to bake bread—that was the point of college, after all. My grandmother never taught me because she assumed that baking bread was something everybody knew how to do. Eventually, I learned to bake bread on my own. And years later, my mother decided that bread was something she was interested in as well. Together, through the course of many trials and errors, we cloned the Swedish rye bread my grandmother had made so effortlessly. Retrieving that one little scrap of the past filled us with a profound sense of contentment. When I think of my mother’s house, that day is the one I remember.")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "rps13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "page13",
      "src": "Images/page-13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e63313"
    }
  }, [_vm._v("Of course, it takes more than a loaf of bread to create a home that is gracious and comforting to those within. But sometimes, the exact qualities seem elusive. Showy luxury and stadiumsized space—the qualities we are supposed to strive for—don’t seem to be the secret. The ingredients that go into a home that embraces and welcomes aren’t obvious, and they aren’t exactly the same for every home. Yet over the years I’ve noticed that such homes have certain qualities in common; understanding them can help us restore much of what’s been mislaid in the scramble and tussle of modern life. Here are those key qualities.")]), _vm._v(" "), _c('p', {
    staticClass: "sercov",
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "id": "rps14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "page14",
      "src": "Images/page-14.jpg"
    }
  })]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "2%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "96%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "2%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/Bracketleft.jpg"
    }
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "cap"
  }, [_vm._v("One of the hallmarks of a warm and inviting kitchen is providing a central focus, such as this antique island complete with barstools.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/Bracketright.jpg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e71016"
    }
  }, [_vm._v("HARMONY")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e71516"
    }
  }, [_vm._v("There are all sorts of harmony, starting with the house itself. A home that suits the neighborhood, and suits the lot it sits on, conveys a sense of neighborliness and community. I always wonder about the person who breaks up a block of vintage bungalows to erect a high-tech concrete box, or the person so determined to have his starter castle that there’s scarcely a foot of space between the house and the lot’s perimeter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e76016"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("Go out of your way")])]), _vm._v(" to establish a bit of neighborhood harmony. A cousin told me about a good friend of hers who owned a large dog. Sweet and gentle, to be sure, but a dog that size could leave quite a mess if he were to slip out of his yard. So soon after moving, the owner took her dog, Vernors, on a meet-and-greet around the neighborhood. Vernors left a business card with each neighbor asking that they please call his home if he should get out and someone would be over to clean up immediately. That was all it took, and Vernors has been a popular member of the community ever since. All most folks want to know  is that, if a problem arises, they can mention it without risking an ugly episode of porch rage.")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "rps16"
    }
  }, [_c('img', {
    attrs: {
      "alt": "page16",
      "src": "Images/page-16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e84017"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("No room should be an island.")])]), _vm._v(" If stepping from the living room to the kitchen is like stepping from Versailles to American farm country, and the dining room is a lesson in Danish modern, the effect is jarring and the rooms feel closed off from each other. When rooms harmonize, each seems an extension of the next, and the whole house feels more spacious and at peace with itself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e88317"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("Select harmonious furniture.")])]), _vm._v(" Does the furniture suit the purpose of the room it’s in? Or does it hinder it, like a dining table centerpiece that’s too big, the drive-in sized television set in the conversation room, or the reading corner with the beautiful but impossible-to-readby lamp?")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e92317"
    }
  }, [_vm._v("CLEANLINESS")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e92817"
    }
  }, [_vm._v("The world makes a lot of demands on us. There’s always something that needs to be done, someone we need to make time for, an item to pick up here and another to drop off there, traffic that tests our limits, friends and coworkers caught in dramas of their own, and often, at the end of the day, any number of to-dos and should-dos that already casting their shadow over tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e96917"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("Your home should be a refuge")])]), _vm._v(" from all that. The “shelter” in the food, clothing, and shelter equation means more than mere protection from wind and rain or a place to stow one’s belongings. It also means shelter from the stresses of the greater world, a little oasis where we can relax, pursue our own interests, share time with those we love.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e100917"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("A home that’s dirty or cluttered")])]), _vm._v(" can’t fulfill that part of the mission. How can it, when you see new tasks waiting at every turn: the vacuum cleaner that didn’t get put away, the pile of mail waiting to be sorted through, the laundry you meant to put away three days ago, the gritty, sticky corner of the kitchen floor that you meant to go at with hot water and suds but haven’t quite gotten around to. And even if you put all these chores off one more day, you still feel oppressed by them, drained of energy and a little guilty. Far from being a mundane concern, learning how to keep a house clean and uncluttered is the groundwork for many loftier achievements—happiness, thriving family relationships, intellectual pursuits, hobbies that nurture creativity, and renewed energy and enthusiasm for the life we live outside the home.")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "rps18"
    }
  }, [_c('img', {
    attrs: {
      "alt": "page18",
      "src": "Images/page-18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e131319"
    }
  }, [_vm._v("A NEATLY ORGANIZED RIBBON AND BUTTON STATION HELPS TO MAKE WRAPPING PRESENTS AND CRAFTING PROJECTS IN UNIQUE PACKAGES A JOYFUL AND EFFICIENT TASK.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e110219"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("Beyond a certain level of clean,")])]), _vm._v(" I’ve noticed that homes that feel welcoming all have a “tended to” look. Items that need repair aren’t in evidence; they’ve been removed to the basement or garage. Valentine’s streamers aren’t dangling as Easter eggs are being deviled. Most of all, someone has taken the trouble to make things nice—to fluff up the pillows, fill a vase with flowers, put down freshly laundered throw rugs, or set a pot of potpouri to simmer. These little grace notes of sight and scent do more to make a home feel gracious and expansive than all the expensive furniture in the world.")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e116819"
    }
  }, [_vm._v("EFFICIENCY")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e117319"
    }
  }, [_vm._v("Before you conjure images of Captain von Trapp marching his children around to the beat of a military whistle, or a time management specialist moving people from one task to another without a single pause, rest assured: that’s not what we mean. Yes, it might be more efficient to set the table for breakfast as soon as dinner is finished—but then no one could play Monopoly at the kitchen table or relax over a cup of bedtime cocoa, now could they?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e122319"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("An efficient home")])]), _vm._v(" is one that runs smoothly and doesn’t get in the way of the people who live there. This takes some behind-the-scenes effort—planning the rooms to accommodate the needs and activities of the people who live in them, understanding what tasks need to be done and who will do them, and planning for the “when” and “how” of seeing the job through. Just as in the days of the family farm, efficiency means that everybody has a job to do, and pitches in when someone else is sick, has a test to study for, or extra responsibilities outside the home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e128619"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("Those who live in gracious homes")])]), _vm._v(" tend not to be wasteful. Furniture and possessions are treated with care and made to last. Water isn’t left running and lights aren’t left on, and possessions aren’t acquired without thought. This means that what is used is needed, what is bought is fully enjoyed, and what’s left over can be shared with others.")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "rps20"
    }
  }, [_c('img', {
    attrs: {
      "alt": "page20",
      "src": "Images/page-20.jpg"
    }
  })]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "2%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "96%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "2%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/Bracketleft.jpg"
    }
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "cap"
  }, [_vm._v("This cheerful kitchen displays its plates and bowls in the open. They coordinate beautifully with the blue and white checked tile backsplash.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/Bracketright.jpg"
    }
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "rps21"
    }
  }, [_c('img', {
    attrs: {
      "alt": "page21",
      "src": "Images/page-21.jpg"
    }
  })]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "2%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "96%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "2%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/Bracketleft.jpg"
    }
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "cap"
  }, [_vm._v("Try adding a personal touch with your dish display, such as this hen nesting with stoneware yellow bowls.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/Bracketright.jpg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e139121"
    }
  }, [_vm._v("SELF-RELIANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e139621"
    }
  }, [_vm._v("No one can be truly self-sufficient in this day and age, and I wouldn’t even try, but I’m sure that a way of life in which each of us does just one or two things and outsources all the rest won’t be too rewarding, either.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e142021"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("Households that preserve the do-it-for-ourselves tradition")])]), _vm._v(" seem to me happier, livelier, and more interesting places to be, and the people who live there are almost always people I want to know. You don’t need to spin your own wool or make your own furniture to get in the spirit, either. Try making your own pizza instead of having it delivered, growing no-fuss vegetables like scallions and radishes, or taking on a do-it-yourself project that you’re pretty sure you can do yourself. Pick up a crafting hobby like knitting, quilting, or sewing. You’ll live a richer, more varied life because of it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e148921"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("Fun is another kind of selfreliance")])]), _vm._v(" that’s worth bringing into your home. Turn off the DVD player, shut down the computer, and actually do something. Read a book, play charades, work a jigsaw puzzle, get out the badminton set, let the rafters ring with activity— studies show that any of these will make you happier than another night in front of a glowing screen.")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e153322"
    }
  }, [_vm._v("GENEROSITY")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e153822"
    }
  }, [_vm._v("We’ve all been in one at one time or another—a home that’s the best money can buy, filled with expensive objects and furnished for royalty. There’s just one problem: you can’t wait to get out of the place. It’s amazing how many top-flight homes have a total absence of grace and charm. They’re filled with expensive antiques you’re afraid to sit on, overwhelm you with enough marble to pave the courtyards of Versailles, and do everything they can to make you feel out of place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e159022"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("At the other extreme is the modest home")])]), _vm._v(" that might charm if only the owner would stop fussing over everything and everyone in it. Sigmund Freud may never have cleaned a house, but he had this one pegged. In an early case study, describing the home life of his troubled young client, he noted that household was a spacious and well-appointed one, but presided over by a mother who cleaned and polished so relentlessly that it was impossible for anyone who lived there to enjoy it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e164622"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("A home has to be comfortable.")])]), _vm._v(" Once upon a time, everyone knew that, and filled their rooms with overstuffed chairs, afghans, and padded footstools. That was before the age of overdesign. Now, all too often, the way a chair looks can trump its usability, and homeowners get carried away with the notion of staging a room to look just so.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e168622"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("Try sitting in every chair")])]), _vm._v(" in the room for about half an hour. Is it comfortable? You should never keep a piece of furniture you don’t like sitting in—even if it’s a chair that only gets used when company comes. What kind of logic is that? While you’re sitting there, you might also try reading a book or having a cup of tea. How’s the lighting? Is there a place to set your teacup? Oh, that’s right. You decided a lamp would spoil the room’s look entirely, and no one should be drinking tea there anyway because the cup might leave a ring. While you’re holding on to your teacup, evaluate the room’s emotional effect. Do you feel at ease and confident, or do you feel that you do not fit, and perhaps someone else should be sitting in your spot?")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e175822"
    }
  }, [_vm._v("YOU SHOULD NEVER KEEP A PIECE OF FURNITURE YOU DON’T LIKE SITTING IN—EVEN IF IT’S A CHAIR THAT ONLY GETS USED WHEN COMPANY COMES.")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "rps23"
    }
  }, [_c('img', {
    attrs: {
      "alt": "page23",
      "src": "Images/page-23.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e179024"
    }
  }, [_vm._v("PERSONALITY")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e179524"
    }
  }, [_vm._v("Homes that welcome you in don’t eradicate signs of life, they embrace them. They reflect the personalities and interests of the people who live there and convey a sense of life going on in all its bustling, varied, and not necessarily predictable ways.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e182224"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("I have a friend")])]), _vm._v(" who’s one of the liveliest, most intelligent women I know, one of those people with a dynamic personality and sparkling presence that everyone responds to. Yet the first time I visited her home, I was stunned. The rooms were tasteful and well-decorated, the furniture was comfortable and inviting, yet I was bored out of my mind. There wasn’t a single scrap of my friend’s personality in the room, or of her husband’s or her children’s. I felt I’d visited a rather nice suite in a very good hotel. When we became better friends, she told me about her collection of vintage tablecloths and kitchenware, and the daisystrewn dishes she’d inherited from an aunt. Thinking of how much I would have enjoyed seeing these things, I asked her why she didn’t put them out. She told me she thought they might “clutter up” the kitchen. I’m not so sure they would, but even if they did, I’d take some really good, interesting clutter over antiseptic, impersonal neatness any day of the week.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e192724"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("Putting personality in the place you live")])]), _vm._v(" is easy—just go with your tastes and interests. If you think the Depression-era glass plates your grandmother got with cereal coupons is prettier than your sophisticated, eggshellthin Rosenthal, go ahead, fill your shelves with the Depression glass and put the Rosenthal away. If you adore your collection of Populuxe barware, complete with pink elephants cavorting around a cocktail shaker, find a way to work it into your decor. The easy way to do this, of course, is to start out with an overall style you like rather than the trend of the moment or the style that’s so neutral it doesn’t even have a name. Chances are that all the things you love and have acquired over the years go together pretty well, and will work to create a home that reflects your personality. The worst question to be asked by the person who visits for the first time is, “I love this, who’s your decorator?” But when you hear someone say, “This place is so you,” you know you’ve created something special.")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "rps25"
    }
  }, [_c('img', {
    attrs: {
      "alt": "page25",
      "src": "Images/page-25.jpg"
    }
  })]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "10%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/Bracketleft.jpg"
    }
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "cap"
  }, [_vm._v("A collection of mismatched eggcups becomes a quirky candleset, perfectly matching the owner’s tastes.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/Bracketright.jpg"
    }
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "rps26"
    }
  }, [_c('img', {
    attrs: {
      "alt": "page26",
      "src": "Images/page-26.jpg"
    }
  })]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "10%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/Bracketleft.jpg"
    }
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "cap"
  }, [_vm._v("A set of binoculars invites guests to take a seat on this quaint porch and indulge in a few moments of birdwatching.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/Bracketright.jpg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e207627"
    }
  }, [_vm._v("JOY")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e208127"
    }
  }, [_vm._v("Warm, life-filled homes have a pulse and a rhythm. They celebrate the seasons with wreaths of autumn leaves in the fall and baskets of tulips in the spring. They get dressed for the holidays and sometimes, just like their occupants, they get new haircuts and outfits and even major makeovers. Most of all, they develop traditions of their own. It may be a gesture as simple as turning on a lamp in the window for the one coming home, or popping corn and watching movies together on Friday nights. It may be rushing out to toast the first snowfall of the season with a bottle of champagne or an annual summer garage sale, held by everyone in the house, with the proceeds going into a piggy bank marked “Disney World.” It matters less what the traditions are than that they exist. When we go away, this is what we remember—how things were done in that special place, and how the doing and the sharing filled us with happiness and a sense of well-being.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e218427"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "medium",
      "color": "#AE5485"
    }
  }, [_c('i', [_vm._v("They say that people fall in love")])]), _vm._v(" with houses, but houses never love you back, and I suppose that’s true. But if you take time to manage your little part of the world, if you put energy and thought into the way things are done, you’ll receive some things that are pretty valuable in return— comfort and joy, time to relax and appreciate your life and the people in it, and rooms that welcome you each time you return. All in all, pretty well worth the effort.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02d868ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Susa_ISBN9781588169167_epub_ch01_r1.vue
// module id = 81
// module chunks = 0